import { render, staticRenderFns } from "./SimClassDetail.vue?vue&type=template&id=75cfb6ef&scoped=true"
import script from "./SimClassDetail.vue?vue&type=script&lang=js"
export * from "./SimClassDetail.vue?vue&type=script&lang=js"
import style0 from "./SimClassDetail.vue?vue&type=style&index=0&id=75cfb6ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cfb6ef",
  null
  
)

export default component.exports